import { render } from "./CreateUser.vue?vue&type=template&id=2b9b883f&scoped=true&ts=true"
import script from "./CreateUser.vue?vue&type=script&lang=ts"
export * from "./CreateUser.vue?vue&type=script&lang=ts"

import "./CreateUser.vue?vue&type=style&index=0&id=2b9b883f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b883f"]])

export default __exports__